var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKotlin = function SvgKotlin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "kotlin_svg__a",
    x1: 500.003,
    x2: -0.097,
    y1: 579.106,
    y2: 1079.206,
    gradientTransform: "translate(15.534 -96.774) scale(.1939)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#e44857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#c711e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f52ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kotlin_svg__a)",
    d: "M112.484 112.484H15.516V15.516h96.968L64 64Zm0 0"
  })));
};
export default SvgKotlin;